import gb4 from "../../../assets/Product_img/gb_IV/1.jpg";
import gb41 from "../../../assets/Product_img/gb_IV/2.jpg";
import first from "../../../assets/Product_img/common/1.jpeg";
import second from "../../../assets/Product_img/common/2.jpeg";
import third from "../../../assets/Product_img/common/3.jpeg";
import four from "../../../assets/Product_img/common/4.jpeg";
import five from "../../../assets/Product_img/common/5.jpeg";

export const proLabGB4 = {
  hero: {
    title: "Pro-Lab ",
    title2: "GB IV",
    description:
      "Engineered for advanced research and industrial environments requiring exceptional inert atmosphere stability and workspace capacity.",
    imgUrl:
    gb41
  },

  productsDetails: {
    imgList: [
      gb4,gb41,first,second,third,four,five
    ],

    productName: "Pro-Lab GB IV Glove Box",

    description:
      "The Pro-Lab GB IV system delivers ultra-stable oxygen and moisture control with advanced purification, a spacious working chamber, and rugged construction. It is ideal for high-precision workflows in materials research, battery development, pharmaceutical processes, and industrial R&D.",

    keyFeatures: [
      "Exceptional inert atmosphere stability (<1 ppm O₂ & H₂O)",
      "Large internal workspace to support sizeable experimental setups",
      "High-capacity purification with multi-stage filtering",
      "Robust stainless-steel construction for intensive usage",
      "Modular expansion options for automation and instrumentation",
    ],

    download: {
      title: "Download Brochure PDF",
      downloadLink: "",
    },

    reviewList: [],
    descriptionTitle:"Product Description",

    briefDescirption:
      "The Pro-Lab GB IV Glove Box sets the standard for high-performance controlled-atmosphere systems. Equipped with premium purification, ergonomic design, and scalable architecture, it enables reliable handling of air-sensitive materials in demanding research and production workflows.",
  },
};
